/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */
import { useTableColumn } from 'xrk-components';
import { date, fen2yuan } from '@/utils/formatter';
import {
  ORDER_PRICE_TYPE,
  PAY_TYPE,
  ORDER_PAY_STATUS,
  TERMINAL_TYPE
} from '../constants';
import { PAY_PASSAGEWAY_MAPPING } from '@/common/constants/bank/index';
import { taxPatternMapping } from '@constants/project';

/** 序号 */
export const indexCol = useTableColumn({
  type: 'index',
  label: '序号'
});

/** 订单编号 */
export const orderNoCol = useTableColumn({
  label: '订单编号',
  prop: 'orderNo'
});

/** 关联项目服务费订单编号 */
export const refOrderNoCol = useTableColumn({
  label: '关联项目服务费订单编号',
  prop: 'refOrderNo'
});

/** 关联客户结算单号 */
export const refSettlementNoCol = useTableColumn({
  label: '关联客户结算单号',
  prop: 'refSettlementNo'
});

/** 个体工商户名称 */
export const individualNameCol = useTableColumn({
  label: '个体工商户名称',
  prop: 'individualName'
});

/** 终端服务人员 */
export const fullNameCol = useTableColumn({
  label: '终端服务人员',
  prop: 'userName'
});

/** 客户名称 */
export const customerNameCol = useTableColumn({
  label: '客户名称',
  prop: 'customerName'
});

/** 手机号 */
export const phoneCol = useTableColumn({
  label: '手机号',
  prop: 'phone'
});

/** 结算任务量（条） */
export const settlementTaskCountCol = useTableColumn({
  label: '结算任务量（条）',
  prop: 'finishSum'
});

/** 终端结算单价（元） */
export const taskPriceCol = useTableColumn({
  label: '终端结算单价（元）',
  prop: 'terminalSettlementPrice',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 终端结算金额（元） */
export const projectPayPriceCol = useTableColumn({
  label: '终端结算金额（元）',
  prop: 'terminalSettlementAmount',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 结算单号 */
export const industryFenpeiCodeCol = useTableColumn({
  label: '结算单号',
  prop: 'settlementCode'
});

/** 关联客户结算单号 */
export const relatedSettlementCodeCol = useTableColumn({
  label: '关联客户结算单号',
  prop: 'refSettlementNo'
});

/** 项目名称 */
export const projectNameCol = useTableColumn({
  label: '项目名称',
  prop: 'projectName'
});

/** 项目编码 */
export const projectNoCol = useTableColumn({
  label: '项目编码',
  prop: 'projectCode'
});

/** 交易结构 */
export const taxCollectionPatternCol = useTableColumn({
  label: '交易结构',
  prop: 'taxPattern',
  formatter({ cellValue }) {
    return taxPatternMapping[cellValue]?.label;
  }
});

/** 终端类型 */
export const terminalTypeCol = useTableColumn({
  label: '终端类型',
  prop: 'terminalType',
  formatter({ cellValue }) {
    return TERMINAL_TYPE[cellValue]?.label;
  }
});

/** 工业名称 */
export const entpNameCol = useTableColumn({
  label: '工业名称',
  prop: 'industryName'
});

/** 供应商名称 */
export const supplierNameCol = useTableColumn({
  label: '供应商名称',
  prop: 'supplierName'
});

/** 订单生成时间 */
export const orderTimeCol = useTableColumn({
  label: '订单生成时间',
  prop: 'orderTime',
  formatter: ({ cellValue }) => date(cellValue)
});

/** 订单支付时间 */
export const orderPayTimeCol = useTableColumn({
  label: '订单支付时间',
  prop: 'orderPayTime',
  formatter: ({ cellValue }) => date(cellValue)
});

/** 订单完结时间 */
export const orderFinishTimeCol = useTableColumn({
  label: '订单完结时间',
  prop: 'orderFinishTime',
  formatter: ({ cellValue }) => date(cellValue)
});

/** 终端到账时间 */
export const endPointFinishPayAtCol = useTableColumn({
  label: '终端到账时间',
  prop: 'terminalAccountTime',
  formatter: ({ cellValue }) => date(cellValue)
});

/** 订单类型 */
export const orderTypeCol = useTableColumn({
  label: '订单类型',
  prop: 'orderType',
  formatter({ cellValue }) {
    return ORDER_PRICE_TYPE[cellValue]?.label;
  }
});
/** 供应商支付方式 */
export const payTypeCol = useTableColumn({
  label: '供应商支付方式',
  prop: 'supplierPayType',
  formatter({ cellValue }) {
    return PAY_TYPE[cellValue]?.label;
  }
});

/** 客户支付方式 */
export const csoPayTypeCol = useTableColumn({
  label: '客户支付方式',
  prop: 'payType',
  formatter({ cellValue }) {
    return PAY_TYPE[cellValue]?.label;
  }
});

/** 支付通道 */
export const payPassagewayCol = useTableColumn({
  label: '支付通道',
  prop: 'payPassagewayCode',
  formatter({ cellValue }) {
    return PAY_PASSAGEWAY_MAPPING?.[cellValue]?.label || '-';
  }
});

/** 订单支付金额（元） */
export const orderPriceCol = useTableColumn({
  label: '订单支付金额（元）',
  prop: 'orderPaymentAmount',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 供应商服务费率（%） */
export const gysSumScaleCol = useTableColumn({
  label: '供应商服务费率（%）',
  prop: 'supplierServiceRate',
  formatter: ({ cellValue }) => fen2yuan(+cellValue)
});

/** 综合服务费率（%） */
export const comprehensiveServiceRateCol = useTableColumn({
  label: '综合服务费率（%）',
  prop: 'comprehensiveRate',
  formatter: ({ cellValue }) => fen2yuan(+cellValue)
});

/** 综合服务费金额（元） */
export const comprehensiveServiceAmountCol = useTableColumn({
  label: '综合服务费金额（元）',
  prop: 'comprehensiveServiceFeeAmount',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 支付状态 */
export const payStatusCol = useTableColumn({
  label: '支付状态',
  prop: 'payStatus',
  formatter({ cellValue }) {
    return ORDER_PAY_STATUS?.[cellValue]?.label || '-';
  }
});

/** 供应商支付状态 */
export const supplierPayStatusCol = useTableColumn({
  label: '供应商支付状态',
  prop: 'supplierPayStatus',
  formatter({ cellValue }) {
    return ORDER_PAY_STATUS?.[cellValue]?.label || '-';
  }
});

/** 支付对象 */
export const payTargetCol = useTableColumn({
  label: '支付对象',
  prop: 'paymentRecipient'
});

/** 项目结算金额（元/含税） */
export const projectSettlementScalePriceCol = useTableColumn({
  label: '项目结算金额（元/含税）',
  prop: 'projectSettlementAmount',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 增值税率（%） */
export const vatRateCol = useTableColumn({
  label: '增值税率（%）',
  prop: 'incrementTaxRate',
  formatter: ({ cellValue }) => fen2yuan(+cellValue)
});

/** 平台/商务服务费率（%） */
export const commissionCol = (type: number) => {
  const label = type === 1 ? '平台服务费率（%）' : '商务服务费率（%）';
  const prop = type === 1 ? 'platformServiceFeeRate' : 'businessServiceFeeRate';
  return useTableColumn({
    label,
    prop,
    formatter: ({ cellValue }) => fen2yuan(+cellValue)
  });
};

/** 平台/商务服务费金额（元） */
export const platformServicesPriceCol = (type: number) => {
  const label = type === 1 ? '平台服务费金额（元）' : '商务服务费金额（元）';
  const prop = type === 1 ? 'platformServiceFee' : 'businessServiceFee';
  return useTableColumn({
    label,
    prop,
    formatter: ({ cellValue }) => fen2yuan(cellValue)
  });
};

/** 终端结算金额（元） */
export const csoPriceSumCol = useTableColumn({
  label: '终端结算金额（元）',
  prop: 'terminalSettlementAmount',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 终端支付进度 */
export const csoPayProgressCol = useTableColumn({
  label: '终端支付进度',
  prop: 'terminalPaymentScheduling'
});
